import { render } from "./UploadAndPreviewFile.vue?vue&type=template&id=1bac865c&scoped=true&lang=pug"
import script from "./UploadAndPreviewFile.vue?vue&type=script&lang=js"
export * from "./UploadAndPreviewFile.vue?vue&type=script&lang=js"

import "./UploadAndPreviewFile.vue?vue&type=style&index=0&id=1bac865c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bac865c"]])

export default __exports__